import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { withRouter } from 'react-router-dom';

import classNames from 'classnames';

import { Image, Label, Menu, Popup } from 'semantic-ui-react';

import iconHelp from '../img/icon-help.svg';

import '../css/TopNav.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';

import { VIEW_SELECTION } from '../managers/NavigationManager';

import {
  TOP_NAV_NAME
} from '../constants';

import GuidedTourService from '../services/GuidedTourService';
import InitService from '../services/InitService';
import PopupService from '../services/PopupService';
import ProfileMenuService from '../services/ProfileMenuService';
import TopNavService from '../services/TopNavService';
import UserService from '../services/UserService';

import { getEnvironmentSpecificTranslationKey } from '../utils/environmentHelper';

export default
@inject(
  'appManager',
  'contentManager',
  'filteredHeaderTableManager',
  'navigationManager',
  'notificationManager',
  'productManager',
  'schoolManager',
  'topNavManager',
  'userManager')
@observer
class AdminTopNav extends Component {
  constructor() {
    super();
    this.AriaSkipLink = SatCoreComponent('AriaSkipLink');
    this.EnvelopeIcon = SatCoreComponent('EnvelopeIcon');
    this.LogoButtons = SatCoreComponent('LogoButtons');
    this.ProfileMenu = SatCoreComponent('ProfileMenu');
    this.menuBarRef = React.createRef();
  }

  componentDidMount() {
    const { appManager, history, schoolManager, topNavManager } = this.props;

    topNavManager.setActiveTopNavName(TOP_NAV_NAME.AdminTopNav);

    schoolManager.setSearchText('');

    InitService.initActiveUserRoleAsHtmlBodyAttr();

    // send user to a specified custom 'main' nav tab if the following conditions are true:
    // (1) user has the proper satellite and publisher permissions to see the given tab (i.e. the tab is in the displayed list), and
    // (2) user is on currently on the dashboard tab (i.e. likely via redirection after login), and
    // (3) user has likely not manually clicked on the 'dashboard' nav tab since login (i.e. ?view='dashboard' param is absent), and
    // (4) satelliteLayoutConfig has a 'mainTopNavId' that is **not** the dashboard ('default')
    const { topNavObj } = TopNavService.getAdminMainTopNavInfo() || {};
    const mainTopNavId = topNavObj?._id;

    if (topNavObj?.functionKey) {
      const pathname = window?.location?.pathname;
      const urlParams = new URLSearchParams(window.location.search);
      if (mainTopNavId !== 'default' && pathname === '/' && urlParams?.get?.('view') !== VIEW_SELECTION.DASHBOARD) {
        this[topNavObj?.functionKey]?.();
      }
    }

    this.unlisten = history?.listen?.((location, _action) => {
      appManager.setLocation(location);
    });
  }

  componentWillUnmount() {
    InitService.removeHtmlBodyRoleAttr();
    this.unlisten?.();
  }

  handleClickProfile = () => {
    const { history, navigationManager } = this.props;
    navigationManager.clearAllPaths();
    history.push('/profile', { url: history.createHref(history.location) });
  }

  handleClickGuidedTour = () => {
    const { topNavManager } = this.props;
    topNavManager.setIsTopNavProfileMenuOpen(false);
    // Small delay to allow menu to fully close and clear active states before launching tour
    setTimeout(() => {
      GuidedTourService.launchGuidedTour();
    }, 300);
  };

  handleClickRoleSwitcher = () => {
    const { history } = this.props;
    GuidedTourService.removeGuidedTourLauncherIfApplicable();
    UserService.showRoleSwitcher(history);
  };

  handleClickExternalDashboard = async () => {
    const { history } = this.props;
    await history.push(`/externalDashboard?view=${VIEW_SELECTION.EXTERNAL_DASHBOARD}`);
  }

  handleClickSchools = async () => {
    const {
      filteredHeaderTableManager, history,
      navigationManager, schoolManager
    } = this.props;
    navigationManager.setView(VIEW_SELECTION.DASHBOARD);
    navigationManager.clearAllPaths();
    schoolManager.setSearchText('');
    filteredHeaderTableManager.clearAll();
    await history.push(`/?view=${VIEW_SELECTION.DASHBOARD}`);
  }

  handleClickUsers = async () => {
    const {
      filteredHeaderTableManager, history,
      navigationManager, schoolManager
    } = this.props;
    navigationManager.setView(VIEW_SELECTION.USERS);
    navigationManager.clearAllPaths();
    filteredHeaderTableManager.clearAll();
    schoolManager.setSearchText('');
    await history.push(`/users?view=${VIEW_SELECTION.USERS}`);
  }

  handleClickContent = async () => {
    const {
      filteredHeaderTableManager, history,
      navigationManager, schoolManager, userManager
    } = this.props;
    if (userManager.canViewSatelliteContent) {
      navigationManager.setView(VIEW_SELECTION.CONTENT);
      navigationManager.clearAllPaths();
      schoolManager.setSearchText('');
      filteredHeaderTableManager.clearAll();
      await history.push(`/content?view=${VIEW_SELECTION.CONTENT}`);
    } else {
      await history.replace('/');
    }
  }

  handleClickProducts = async () => {
    const {
      filteredHeaderTableManager, history,
      navigationManager, schoolManager
    } = this.props;
    navigationManager.setView(VIEW_SELECTION.PRODUCTS);
    navigationManager.clearAllPaths();
    schoolManager.setSearchText('');
    filteredHeaderTableManager.clearAll();
    await history.push(`/products?view=${VIEW_SELECTION.PRODUCTS}`);
  }

  handleClickClassrooms = async () => {
    const {
      filteredHeaderTableManager, history,
      navigationManager, schoolManager
    } = this.props;
    navigationManager.setView(VIEW_SELECTION.CLASSROOMS);
    navigationManager.clearAllPaths();
    schoolManager.setSearchText('');
    filteredHeaderTableManager.clearAll();
    await history.push(`/classrooms?view=${VIEW_SELECTION.CLASSROOMS}`);
  }

  handleClickTestBuilder = async () => {
    const {
      filteredHeaderTableManager, history,
      navigationManager, schoolManager, userManager
    } = this.props;
    if (userManager.canViewSatelliteTestBuilder) {
      navigationManager.setView(VIEW_SELECTION.TEST_BUILDER);
      navigationManager.clearAllPaths();
      schoolManager.setSearchText('');
      filteredHeaderTableManager.clearAll();
      await history.push(`/adminTestbuilder?view=${VIEW_SELECTION.TEST_BUILDER}`);
    }
  }

  handleClickReports = async () => {
    const {
      filteredHeaderTableManager,
      history,
      navigationManager,
      schoolManager
    } = this.props;
    if (navigationManager.viewSelection === VIEW_SELECTION.REPORTS) {
      await history.push('/');
    }
    navigationManager.setView(VIEW_SELECTION.REPORTS);
    navigationManager.clearAllPaths();
    schoolManager.setSearchText('');
    filteredHeaderTableManager.clearAll();
    await history.push(`/reports?view=${VIEW_SELECTION.REPORTS}`);
  }

  showHelpWindow = async () => {
    const { contentManager } = this.props;
    if (contentManager.helpWindowUrl !== null) {
      window.open(contentManager.helpWindowUrl, '_blank');
    }
  }

  showNotifications = () => {
    const { history } = this.props;
    history.push(`/notifications?view=${VIEW_SELECTION.NOTIFICATIONS}`);
  }

  showResources = async () => {
    const { history, navigationManager } = this.props;
    navigationManager.setView(VIEW_SELECTION.RESOURCES);
    await history.push(`/resources?view=${VIEW_SELECTION.RESOURCES}`);
  }

  handleFetchTotalNotificationCountsIfApplicable = async ({ view } = {}) => {
    // NotificationsView force-refreshes counts on mount; skip here to avoid a double call
    if (view === VIEW_SELECTION.NOTIFICATIONS) {
      return;
    }
    const { notificationManager, userManager } = this.props;
    await notificationManager.fetchTotalNotificationCounts({ userId: userManager.userId });
  }

  handleLogout = async () => {
    const { history, navigationManager, t, topNavManager } = this.props;

    const strOfItemsToPreserve = '';

    const externalLogoutUrlKey = getEnvironmentSpecificTranslationKey('externalLogoutUrl');
    const externalLogoutUrl = t(externalLogoutUrlKey);

    InitService.doLogoutCleanUp(strOfItemsToPreserve, { externalLogoutUrl });

    if (!externalLogoutUrl || !topNavManager.allowLoginRedirectUrl) {
      navigationManager.setView(VIEW_SELECTION.LOGIN);
      history.replace('/signin');
    }
  }

  isViewSelected = (view) => {
    const { navigationManager: { viewSelection } } = this.props;
    return viewSelection !== null && viewSelection === view;
  }

  isViewSelectedClass = (view) => (this.isViewSelected(view) ? 'selected' : null);

  renderMenuItem = (children, view, props, {
    _id,
    /* navTranslationKey = '', */
    navTranslationRolloverKey = '',
    urlPathname
  } = {}) => {
    const { productManager, t, topNavManager, userManager } = this.props;

    const { allowAuthKeyTopNavUrlParamAuthentication, treatTopNavTabsAsAnchorTags } = topNavManager;

    const rolloverMessage = t(navTranslationRolloverKey);

    let href;
    if (treatTopNavTabsAsAnchorTags && urlPathname) {
      href = `${urlPathname}?view=${view}`;
      if (allowAuthKeyTopNavUrlParamAuthentication) {
        href += `&authKey=${Auth.authKey}`;
        href += `&activePermissionId=${userManager.activePermissionId}`;
      }
    }

    return (
      PopupService.renderPopup({
        content: rolloverMessage,
        disabled: !rolloverMessage,
        key: _id,
        trigger: (
          <Menu.Item
            aria-current={this.isViewSelectedClass(view) ? 'page' : undefined}
            as={href ? 'a' : 'li'}
            data-nav-item
            href={href}
            role='link'
            tabIndex='0'
            {...props}
            className={['tnav-tab', this.isViewSelectedClass(view), (props || {}).className].filter((className) => className).join(' ')}
            onClick={async (event, _data) => {
              if (href) {
                event.preventDefault();
              }
              await this.handleFetchTotalNotificationCountsIfApplicable({ view });

              if (productManager.shouldShowExpiredLicenseWarning) {
                productManager.setShouldShowExpiredLicenseWarning(false);
              }
              await props.onClick();
            }}>
            {children}
          </Menu.Item>
        ),
        wide: false
      })
    );
  }

  getNavTabs = () => {
    const {
      userManager: {
        canViewClassroomsAsAdmin,
        canViewReportsAsAdmin,
        canViewSatelliteContent,
        canViewSatelliteProducts,
        canViewSatelliteTestBuilder,
        canViewSchoolsAsAdmin,
        canViewUsersAsAdmin,
        isDistrictOrSchoolAssessmentAdmin,
        isProductAdmin
      },
      t
    } = this.props;
    const { props } = this;

    const showSchoolsTab = canViewSchoolsAsAdmin;
    const showUsersTab = canViewUsersAsAdmin;
    const showProductsTab = canViewSatelliteProducts;
    const showContentTab = canViewSatelliteContent;
    const showClassesTab = canViewClassroomsAsAdmin;
    const showTestBuilderTab = canViewSatelliteTestBuilder;
    const showReportsTab = canViewReportsAsAdmin;

    const { USER_TOP_NAV, topNavOrderArray } = TopNavService.getAdminMainTopNavInfo() || {};

    let extraNavTabs = <></>;
    if (props.getNavTabs !== undefined) {
      extraNavTabs = props.getNavTabs(this.props, this);
    }

    return (
      <>
        {topNavOrderArray?.map?.((topNavId) => {
          const tabNavObj = USER_TOP_NAV[topNavId];

          const { _id, className, functionKey, viewSelectionKey } = tabNavObj;

          let { navTranslationKey } = tabNavObj;

          switch (_id) {
            case USER_TOP_NAV.classrooms._id:
              if (!showClassesTab || isProductAdmin) {
                return;
              }
              break;
            case USER_TOP_NAV.libraryContent._id:
              if (!showContentTab) {
                return;
              }
              // Content and Products tab show the same data in different format, preferred label is Products for both.
              navTranslationKey = (showProductsTab || isDistrictOrSchoolAssessmentAdmin) ? 'contentLabel' : 'productsLabel';
              break;
            case USER_TOP_NAV.products._id:
              if (!showProductsTab) {
                return;
              }
              break;
            case USER_TOP_NAV.reports._id:
              if (!showReportsTab) {
                return;
              }
              break;
            case USER_TOP_NAV.schools._id:
              if (!showSchoolsTab) {
                return;
              }
              break;
            case USER_TOP_NAV.testBuilder._id:
              if (!showTestBuilderTab) {
                return;
              }
              break;
            case USER_TOP_NAV.users._id:
              if (!showUsersTab || isProductAdmin) {
                return;
              }
              break;
          }
          return this.renderMenuItem(t(navTranslationKey), VIEW_SELECTION[viewSelectionKey], {
            className, onClick: this[functionKey]
          }, {
            ...(tabNavObj || {})
            // navTranslationKey, navTranslationRolloverKey
          });
        }).filter((tabNavObj) => !!tabNavObj)}
        {extraNavTabs}
        {this.getAdditionalTopNavExternalResources()}
      </>
    );
  }

  getHelpLink = () => {
    const { contentManager } = this.props;
    if (contentManager.helpWindowUrl !== undefined && contentManager.helpWindowUrl !== null && contentManager.helpWindowUrl !== '') {
      return this.renderMenuItem(
        <Image alt='' aria-label='Help link' src={iconHelp} />, null, { className: 'help-nav', onClick: this.showHelpWindow });
    }
  }

  /**
   * Render top-nav menu external resource url item(s) for each entry in the satellite's
   * `additionalAdminTopNavExternalResources` config.
   *
   * A flexible alternative (or addition) to the traditional single Help/Resources
   * link: define any number of external resource links, each with its own label,
   * and optionally attach runtime params (e.g. `authKey`) via an entry's `urlParamKeys`.
   */
  getAdditionalTopNavExternalResources = () => {
    const { t, topNavManager } = this.props;

    const { additionalAdminTopNavExternalResources } = topNavManager;

    if (!Array.isArray(additionalAdminTopNavExternalResources) || !additionalAdminTopNavExternalResources?.length) {
      return null;
    }

    return additionalAdminTopNavExternalResources.map((resourceUrlObj) => {
      if (typeof resourceUrlObj !== 'object' || !resourceUrlObj?._id) {
        return;
      }

      const className = resourceUrlObj.className || classNames('resources', resourceUrlObj._id);
      const navTranslationKey = resourceUrlObj.navTranslationKey || resourceUrlObj._id;
      const viewSelectionKey = resourceUrlObj.viewSelectionKey || 'resources';

      const handleClickExternalResource = () => {
        const externalResourceUrl = TopNavService.appendTopNavExternalResourceUrlParams(resourceUrlObj);
        if (externalResourceUrl) {
          window.open(externalResourceUrl);
        }
      };

      return this.renderMenuItem(t(navTranslationKey), VIEW_SELECTION[viewSelectionKey], {
        className, onClick: handleClickExternalResource
      }, {
        ...(resourceUrlObj || {}),
        className,
        navTranslationKey,
        viewSelectionKey
      });
    }).filter((obj) => obj);
  }

  getNotificationLink = () => {
    const { notificationManager, t, topNavManager } = this.props;

    const { topNavNotificationCountLabel, totalNotificationCount } = notificationManager;

    const { allowTopNavEnvelopeNotificationIcon, showFullNotificationBanner } = topNavManager;

    const hasNotifications = totalNotificationCount > 0;
    const allowNotificationsMenuItem = allowTopNavEnvelopeNotificationIcon || hasNotifications;

    if (allowNotificationsMenuItem) {
      let notificationMenuItem;
      if (showFullNotificationBanner) {
        notificationMenuItem = (
          <div className='notification-count-wrapper notification-count'>
            <div>
              {`Notifications (${topNavNotificationCountLabel})`}
            </div>
          </div>
        );
      } else if (topNavManager.allowTopNavEnvelopeNotificationIcon) {
        const { EnvelopeIcon } = this;
        const notificationsLabel = t('notificationsLabel');
        const notificationCountLabel = notificationManager.topNavNotificationCountLabel;
        notificationMenuItem = (
          <EnvelopeIcon
            alt={`${notificationsLabel}: ${notificationCountLabel}`}
            hasNotifications={hasNotifications} />
        );
      } else {
        const notificationsLabel = t('notificationsLabel');
        const notificationCountLabel = notificationManager.topNavNotificationCountLabel;
        notificationMenuItem = (
          <Popup
            hideOnScroll={false}
            hoverable={true}
            on='hover'
            position='bottom center'
            trigger={(
              <div aria-label={`${notificationsLabel}: ${notificationCountLabel}`}
                className='notification-count-wrapper notification-count'>
                <Label circular>
                  {notificationCountLabel}
                </Label>
              </div>
            )}
            wide>
            <div key={1} className='card-value'>{t('notificationsLabel')}</div>
          </Popup>
        );
      }

      return this.renderMenuItem(notificationMenuItem,
        VIEW_SELECTION.NOTIFICATIONS, {
          className: 'help-nav notifications-nav', onClick: this.showNotifications
        }, {
          urlPathname: '/notifications'
        }
      );
    }
  }

  renderProfileMenu = () => {
    const { ProfileMenu, props: { profileMenu, userManager, t } } = this;
    const {
      profile: allowShowProfile = true,
      items: profileMenuOptionsFromMainViewOverride,
      logout: allowShowLogout = true
    } = profileMenu || {};

    const { topNavManager } = this.props;

    const { treatTopNavTabsAsAnchorTags: treatAsHref } = topNavManager;

    const { allowSwitchRole } = userManager;
    const hasMultipleRoles = UserService.getAvailableRoleCount() > 1;

    const { getTopNavAnchorHref } = TopNavService;

    const {
      PROFILE_MENU,
      profileMenuOrderArray
    } = ProfileMenuService.getProfileMenuInfo() || {};

    let options = [];
    if (UserService.hasActivePermissionId()) {
      const allMenuOptions = profileMenuOrderArray?.map?.((menuItemId) => {
        const menuItemObj = PROFILE_MENU[menuItemId];

        if (!menuItemObj) {
          return null;
        }

        const { _id, className, functionKey, menuTranslationKey, urlPathname, viewSelectionKey } = menuItemObj;

        switch (_id) {
          case PROFILE_MENU.profile?._id:
            if (!allowShowProfile) {
              return null;
            }
            break;
          case PROFILE_MENU.guidedTour?._id:
            if (!GuidedTourService.shouldAllowGuidedTourLauncher()) {
              return null;
            }
            break;
          case PROFILE_MENU.switchRole?._id:
            if (!allowSwitchRole || !hasMultipleRoles) {
              return null;
            }
            break;
          case PROFILE_MENU.logout?._id:
            if (!allowShowLogout) {
              return null;
            }
            break;
          default:
            break;
        }

        return {
          _id,
          className,
          href: treatAsHref && urlPathname ? getTopNavAnchorHref(urlPathname, VIEW_SELECTION[viewSelectionKey]) : undefined,
          onClick: (event, _data) => {
            if (treatAsHref && urlPathname) {
              event.preventDefault();
            }
            if (functionKey && this[functionKey]) {
              return this[functionKey]();
            }
          },
          text: t(menuTranslationKey)
        };
      }).filter((menuItem) => !!menuItem) || [];

      // If custom items exist, move logout to the end. Otherwise, keep original order.
      if (Array.isArray(profileMenuOptionsFromMainViewOverride) && profileMenuOptionsFromMainViewOverride.length > 0) {
        const profileMenuOptionsWithoutLogout = allMenuOptions.filter((item) => item._id !== 'logout');
        const logoutOption = allMenuOptions.find((item) => item._id === 'logout');

        options = [
          ...profileMenuOptionsWithoutLogout,
          ...profileMenuOptionsFromMainViewOverride,
          ...(logoutOption ? [logoutOption] : [])
        ];
      } else {
        options = allMenuOptions;
      }
    }

    // TODO remove - hardcoded implementation fallback
    // let options = [allowShowLogout && { onClick: this.handleLogout, text: t('logout') }];
    // if (UserService.hasActivePermissionId()) {
    //   options = [
    //     allowShowProfile && {
    //       className: 'profile',
    //       href: treatAsHref ? getTopNavAnchorHref('/profile', VIEW_SELECTION.PROFILE) : undefined,
    //       onClick: (event, _data) => {
    //         if (treatAsHref) {
    //           event.preventDefault();
    //         }
    //         return this.handleClickProfile();
    //       },
    //       text: t('profile')
    //     },
    //     allowSwitchRole && hasMultipleRoles && {
    //       className: 'switchRole',
    //       href: treatAsHref ? getTopNavAnchorHref('/switch-role', VIEW_SELECTION.ROLE_SWITCHER) : undefined,
    //       onClick: (event, _data) => {
    //         if (treatAsHref) {
    //           event.preventDefault();
    //         }
    //         return UserService.showRoleSwitcher(history);
    //       },
    //       text: t('switchRole')
    //     },
    //     ...(profileMenuOptionsFromMainViewOverride || []),
    //     allowShowLogout && { className: 'logout', onClick: this.handleLogout, text: t('logout') }
    //   ];
    // }

    return (
      <ProfileMenu
        {...profileMenu}
        options={options} />
    );
  }

  render() {
    const { additionalClassName = '', history, location, productManager } = this.props;
    const { AriaSkipLink, LogoButtons } = this;

    let topNavClassName = 'topNav';
    topNavClassName += additionalClassName ? ` ${additionalClassName}` : '';

    const allowClickNavLogo = !productManager.isFromProduct;

    return (
      <>
        <Menu
          as={(props) => <header {...props} ref={this.menuBarRef} />}
          className={topNavClassName}
          fixed='top'
          inverted
          onKeyDown={(e) => TopNavService.topNavHandleKeyDown(e, this.menuBarRef)}>
          <LogoButtons history={history} location={location} navButton={allowClickNavLogo} />
          <AriaSkipLink mainContentId='main-content' />
          <Menu.Menu
            aria-label='Admin navigation panel'
            as={(props) => <nav {...props} />}
            position='right'>
            <ul className='nav-list' role='toolbar'>
              {this.getNavTabs()}
              {this.getHelpLink()}
              {this.getNotificationLink()}
            </ul>
            {this.renderProfileMenu()}
          </Menu.Menu>
        </Menu>
      </>
    );
  }
}

SatCoreRegister('AdminTopNav', withRouter(AdminTopNav));
